// components/ads-admin/adsChatPptxExport.js
// Adapter: wraps the shared pptxExport engine for MAD Pilot message format.
//
// MAD Pilot messages use { role, content, _streaming, _error }
// pptxExport expects  { role, text, error_text, status, id, attachments }

import { exportMessageToPpt, exportSessionToPpt } from "../copilot/export/pptxExport";

function adaptMsg(msg, idx) {
  const isError = !!msg._error;
  return {
    id: idx + 1,
    role: msg.role || "assistant",
    text: isError ? "" : String(msg.content || ""),
    error_text: isError ? String(msg.content || "") : "",
    status: isError ? "error" : "ok",
    attachments: [],
    model: null,
    created_at: null,
  };
}

const noBlob = async () => { throw new Error("no attachments"); };

export async function exportMadPilotMessage({ sessionId, msg, msgIdx }) {
  await exportMessageToPpt({
    activeSessionId: sessionId,
    msg: adaptMsg(msg, msgIdx),
    downloadAttachmentBlob: noBlob,
  });
}

export async function exportMadPilotSession({ sessionId, messages, sessionName }) {
  const exportable = (messages || []).filter(m => !m._streaming && m.content);
  if (!exportable.length) return;
  await exportSessionToPpt({
    activeSessionId: sessionId,
    sessionPayload: {
      messages: exportable.map((m, i) => adaptMsg(m, i)),
      session: { title: sessionName || null },
    },
    downloadAttachmentBlob: noBlob,
  });
}
